import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import IconWithText from '../../../Litho/Components/IconWithText/IconWithText';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const IconWithTextData_02 = [
	{
		icon: 'line-icon-Navigation-LeftWindow text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]',
		title: 'Global Network Coverage',
		content:
			'We navigate air, road, and ocean routes worldwide to deliver your cargo safely and on time, no matter the destination.',
	},
	{
		icon: 'line-icon-Cursor-Click2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]',
		title: 'Seamless Booking Experience',
		content:
			'Our digital platform makes shipment scheduling, tracking, and management quick, simple, and hassle-free.',
	},
	{
		icon: 'line-icon-Archery-2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]',
		title: 'Precision and Reliability',
		content:
			'Every delivery is handled with focus and accuracy, ensuring your goods reach their destination in perfect condition.',
	},
	{
		icon: 'line-icon-Female text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]',
		title: 'Dedicated Customer Support',
		content:
			'Our logistics specialists provide personalized assistance and real-time updates throughout your shipping journey.',
	},
];

const OurQualities = () => {
	return (
		<section className='py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px] bg-[#f7f8fc] mb-20'>
			<Container>
				<Row className='justify-center'>
					<m.div
						className='col-xl-6 col-lg-7 col-sm-8 mb-20 text-center w-[51%] xl:mb-[70px] lg:mb-[65px] md:mb-[60px] sm:mb-[55px] md:w-[68%] xs:w-full'
						{...fadeIn}
					>
						<span className='inline-block font-serif text-md uppercase mb-[20px] font-medium  text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e] xs:mb-[15px]'>
							Our Qualities
						</span>
						<h5 className='w-full mb-[20px] font-semibold text-darkgray font-serif -tracking-[1px]'>
							Reliability that travels every mile.
						</h5>
					</m.div>
				</Row>
				<Row className='justify-center'>
					<Col lg={12} md={9} xs={12}>
						<IconWithText
							grid='row-cols-1 row-cols-lg-2 gap-y-10 justify-center'
							theme='icon-with-text-02'
							data={IconWithTextData_02}
							animation={fadeIn}
							animationDelay={0.2}
						/>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default OurQualities;
